export type NativeMainTab = 'home' | 'explore' | 'library' | 'me'
export type NativeGeneratorArgs =
  | { type: 'image'; args: { modelVersionId?: string; loraVersionId?: string } }
  | { type: 'animation'; args: { model?: string; lora?: string } }
  | { type: 'editor' }
  | { type: 'enhancement' }
export type NativeMembershipTarget = 'credits' | 'subscription'

export const NativeNavigation = {
  main: (tab: NativeMainTab) => `pixai://main?tab=${tab}`,
  generator: (args: NativeGeneratorArgs) => {
    const url = `pixai://generator/image/${args.type}`
    if ('args' in args && Object.keys(args.args).length > 0) {
      return `${url}?${new URLSearchParams(args.args).toString()}`
    }
    return url
  },
  membership: (target: NativeMembershipTarget) =>
    `pixai://membership?target=${target}`,
  settings: () => 'pixai://settings',
  profile: (userId?: bigint, username?: string) => {
    if (userId) return `pixai://user/${userId}`
    if (username) return `pixai://user/@${username}`
    return 'pixai://user'
  },
  /** Available >= 3.25.0 */
  editProfile: () => `pixai://edit-account`,
  contest: (contestId: string) => `pixai://contest/${contestId}`,
  taskDetail: (taskId: string) => `pixai://task/${taskId}`,
  artworkDetail: (artworkId: string) => `pixai://artwork/${artworkId}`,
  modelLoraDetail: (modelId: string) => `pixai://model/${modelId}`,
  trainLora: () => 'pixai://train-lora',
  /** Available >= 3.25.0 */
  shop: () => 'pixai://shop',
  /** Available >= 4.5.0 */
  myDecorations: () => 'pixai://my-decorations',
  /** Available >= 4.6.0 */
  coupon: () => 'pixai://coupon',
  /** Available >= 4.10.5 */
  eventPass: () => 'pixai://membership?target=event-pass',
  support: () => 'pixai://support',
}
